webpackJsonp([3,0],{

/***/ 72:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.getAdUserId = exports.getArticleAdKeywords = exports.updateWallpaperPosition = exports.getSupplyType = undefined;
	
	var _keys = __webpack_require__(20);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(24);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(7);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(23);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _rafThrottle = __webpack_require__(389);
	
	var _rafThrottle2 = _interopRequireDefault(_rafThrottle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WALLPAPER_MAGIC_NUMBER = 71; // Find a better way to fetch this...
	
	/* globals getComputedStyle */
	var generateTagFriendlyName = function generateTagFriendlyName(tagName) {
	    return 'vg_' + tagName.trim().toLowerCase().replace(/\s+/g, '-').replace(/-+/g, '-').replace(/,+/g, '').replace(/å/g, 'aa').replace(/ø/g, 'oe').replace(/æ/g, 'ae');
	};
	
	var deviceKeywordMap = function deviceKeywordMap(device) {
	    var deviceMap = {
	        mobile: 'phone',
	        'mobile-app': 'phone',
	        'tablet-app': 'tablet'
	    };
	
	    return deviceMap[device] || device;
	};
	
	var getSupplyType = exports.getSupplyType = function getSupplyType(device) {
	    var supplyType = '';
	
	    switch (device) {
	        case 'desktop':
	            supplyType = 'web_desktop';
	            break;
	
	        case 'tablet-app':
	        case 'tablet':
	            supplyType = 'web_tablet';
	            break;
	
	        case 'mobile-app':
	        case 'mobile':
	            supplyType = 'web_phone';
	            break;
	
	        default:
	            supplyType = 'web_desktop';
	    }
	
	    return supplyType;
	};
	
	var setBodyBackgroundPosition = function setBodyBackgroundPosition(height) {
	    document.body.style.setProperty('background-position', 'center ' + height + 'px', 'important');
	};
	
	/* eslint-disable consistent-return */
	var updateWallpaperPosition = exports.updateWallpaperPosition = function () {
	    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(node) {
	        var getScrollY, updatePosition, _ref2, backgroundPosition;
	
	        return _regenerator2.default.wrap(function _callee$(_context) {
	            while (1) {
	                switch (_context.prev = _context.next) {
	                    case 0:
	                        getScrollY = function getScrollY() {
	                            return window.scrollY || window.pageYOffset;
	                        };
	
	                        updatePosition = new _promise2.default(function (resolve) {
	                            (0, _rafThrottle2.default)(function () {
	                                var top = node.getBoundingClientRect().top + getScrollY();
	                                var backgroundPosition = top + parseInt(getComputedStyle(node).paddingTop.replace('px'), 10);
	
	                                setBodyBackgroundPosition(backgroundPosition);
	
	                                return resolve({
	                                    top: top,
	                                    backgroundPosition: backgroundPosition
	                                });
	                            })();
	                        });
	                        _context.next = 4;
	                        return updatePosition;
	
	                    case 4:
	                        _ref2 = _context.sent;
	                        backgroundPosition = _ref2.backgroundPosition;
	
	
	                        window.addEventListener('scroll', (0, _rafThrottle2.default)(function () {
	                            if (getScrollY() >= backgroundPosition - WALLPAPER_MAGIC_NUMBER) {
	                                setBodyBackgroundPosition(WALLPAPER_MAGIC_NUMBER);
	                            } else {
	                                setBodyBackgroundPosition(backgroundPosition - getScrollY());
	                            }
	                        }));
	
	                    case 7:
	                    case 'end':
	                        return _context.stop();
	                }
	            }
	        }, _callee, undefined);
	    }));
	
	    return function updateWallpaperPosition(_x) {
	        return _ref.apply(this, arguments);
	    };
	}();
	/* eslint-enable */
	
	var getArticleAdKeywords = exports.getArticleAdKeywords = function getArticleAdKeywords(articleObj, device) {
	    var keywords = {};
	    var section = articleObj.section,
	        tags = articleObj.tags;
	
	    if (section === undefined && tags === undefined || (0, _keys2.default)(section).length === 0) {
	        return {};
	    }
	
	    // If parent is set, use that at main appnexus keyword
	    if (section.parent !== undefined) {
	        keywords['no-sno-news-section'] = section.parent.title;
	        keywords['no-sno-news-subsection'] = section.title;
	    } else {
	        keywords['no-sno-news-section'] = section.title;
	    }
	
	    // Send all tags as an array
	    if (tags !== undefined && tags.length > 0) {
	        var tagNames = tags.map(function (tag) {
	            return tag.title;
	        });
	        keywords['no-sno-news-sponsors'] = tagNames;
	    }
	
	    (0, _keys2.default)(keywords).forEach(function (key) {
	        if (Array.isArray(keywords[key])) {
	            keywords[key] = keywords[key].map(function (tag) {
	                return generateTagFriendlyName(tag);
	            });
	        } else {
	            keywords[key] = generateTagFriendlyName(keywords[key]);
	        }
	    });
	
	    // Supply type should be without "vg_"-prefix
	    var supplyType = getSupplyType(device);
	    keywords['aa-sch-supply_type'] = supplyType;
	    keywords['no-sno-device'] = deviceKeywordMap(device);
	
	    return keywords;
	};
	
	var getAdUserId = exports.getAdUserId = function getAdUserId() {
	    var cookie = decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent('_pulse2data').replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || false;
	
	    if (cookie) {
	        return cookie.split(',')[9];
	    }
	
	    return null;
	};

/***/ },

/***/ 183:
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	    desktop: ['netboard_1', 'netboard_2', 'netboard_3'], // same as tablet
	    mobile: ['board_1', 'board_2', 'board_3'],
	    extraSizes: {
	        tablet: {
	            'no-vg-{deviceType}-article_topboard': [[980, 250]]
	        }
	    }
	};

/***/ },

/***/ 760:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var _ref$icon = _ref.icon,
	        iconData = _ref$icon === undefined ? { url: '' } : _ref$icon,
	        _ref$image = _ref.image,
	        imageData = _ref$image === undefined ? { url: '' } : _ref$image,
	        _ref$sponsoredBy = _ref.sponsoredBy,
	        sponsoredBy = _ref$sponsoredBy === undefined ? '' : _ref$sponsoredBy,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title,
	        _ref$clickUrl = _ref.clickUrl,
	        clickUrl = _ref$clickUrl === undefined ? '' : _ref$clickUrl,
	        _ref$imageRatio = _ref.imageRatio,
	        imageRatio = _ref$imageRatio === undefined ? 0 : _ref$imageRatio;
	    return '\n    <a href="' + clickUrl + '" target="_blank">\n        <div class="image-container">\n            <div class="ratio-container" style="padding-bottom: ' + imageRatio + '%;">\n                <img src="' + imageData.url + '" alt="' + title + '" class="image">\n            </div>\n            <img src="' + iconData.url + '" alt="' + sponsoredBy + '" class="icon">\n        </div>\n        <div class="text-wrap">\n            <span class="sponsored-by">Annonse fra ' + sponsoredBy + '</span>\n            <h4 class="title">' + title + '</h4>\n        </div>\n    </a>\n';
	};

/***/ },

/***/ 761:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.partnerstudioTemplate = exports.sponsorTemplate = exports.inhouseTemplate = exports.defaultTemplate = undefined;
	
	var _default = __webpack_require__(760);
	
	var _default2 = _interopRequireDefault(_default);
	
	var _inhouse = __webpack_require__(762);
	
	var _inhouse2 = _interopRequireDefault(_inhouse);
	
	var _sponsor = __webpack_require__(764);
	
	var _sponsor2 = _interopRequireDefault(_sponsor);
	
	var _partnerstudio = __webpack_require__(763);
	
	var _partnerstudio2 = _interopRequireDefault(_partnerstudio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.defaultTemplate = _default2.default;
	exports.inhouseTemplate = _inhouse2.default;
	exports.sponsorTemplate = _sponsor2.default;
	exports.partnerstudioTemplate = _partnerstudio2.default;

/***/ },

/***/ 762:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var _ref$icon = _ref.icon,
	        iconData = _ref$icon === undefined ? { url: '' } : _ref$icon,
	        _ref$image = _ref.image,
	        imageData = _ref$image === undefined ? { url: '' } : _ref$image,
	        _ref$sponsoredBy = _ref.sponsoredBy,
	        sponsoredBy = _ref$sponsoredBy === undefined ? '' : _ref$sponsoredBy,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title,
	        _ref$clickUrl = _ref.clickUrl,
	        clickUrl = _ref$clickUrl === undefined ? '' : _ref$clickUrl,
	        _ref$imageRatio = _ref.imageRatio,
	        imageRatio = _ref$imageRatio === undefined ? 0 : _ref$imageRatio;
	    return '\n        <a href="' + clickUrl + '" target="_blank">\n            <div class="image-container">\n                <div class="ratio-container" style="padding-bottom: ' + imageRatio + '%;">\n                    <img src="' + imageData.url + '" alt="' + title + '" class="image">\n                </div>\n                <img src="' + iconData.url + '" alt="' + sponsoredBy + '" class="icon">\n            </div>\n            <div class="text-wrap">\n                <span class="sponsored-by">Les ogs\xE5</span>\n                <h4 class="title">' + title + '</h4>\n            </div>\n        </a>\n    ';
	};

/***/ },

/***/ 763:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var _ref$icon = _ref.icon,
	        iconData = _ref$icon === undefined ? { url: '' } : _ref$icon,
	        _ref$image = _ref.image,
	        imageData = _ref$image === undefined ? { url: '' } : _ref$image,
	        _ref$sponsoredBy = _ref.sponsoredBy,
	        sponsoredBy = _ref$sponsoredBy === undefined ? '' : _ref$sponsoredBy,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title,
	        _ref$clickUrl = _ref.clickUrl,
	        clickUrl = _ref$clickUrl === undefined ? '' : _ref$clickUrl,
	        _ref$imageRatio = _ref.imageRatio,
	        imageRatio = _ref$imageRatio === undefined ? 0 : _ref$imageRatio;
	    return '\n        <a href="' + clickUrl + '" target="_blank">\n            <div class="image-container">\n                <div class="ratio-container" style="padding-bottom: ' + imageRatio + '%;">\n                    <img src="' + imageData.url + '" alt="' + title + '" class="image">\n                </div>\n            </div>\n            <div class="text-wrap">\n                <span class="sponsored-by"><span class="marker">Annons\xF8rinnhold</span>\n                <img src="' + iconData.url + '" alt="' + sponsoredBy + '" class="icon"></span>\n                <h4 class="title">' + title + '</h4>\n            </div>\n        </a>\n    ';
	};

/***/ },

/***/ 764:
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (_ref) {
	    var _ref$icon = _ref.icon,
	        iconData = _ref$icon === undefined ? { url: '' } : _ref$icon,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? '' : _ref$title;
	    return '\n    <a href="#">\n        <div class="ad ad-sponsor-sticky">\n            <div class="ad-sponsor-wrapper">\n                <span class="sponsor-title">' + title + '</span><img class="sponsor-logo" src="' + iconData.url + '">\n            </div>\n        </div>\n    </a>\n';
	};

/***/ },

/***/ 765:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(17);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(8);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.default = nativeRenderer;
	
	var _nativeTemplates = __webpack_require__(761);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var navigator = global.navigator;
	
	function sendTracking(src) {
	    if (navigator.sendBeacon) {
	        navigator.sendBeacon(src);
	    } else {
	        var img = new global.Image();
	        var handler = function handler() {
	            img.onload = null;
	            img.onerror = null;
	            img = null;
	        };
	        img.onload = handler;
	        img.onerror = handler;
	        img.src = src;
	    }
	}
	
	function track() {
	    var trackers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    trackers.forEach(sendTracking);
	}
	
	var AdNative = function () {
	    function AdNative(_ref) {
	        var nativeObj = _ref.native,
	            adObj = (0, _objectWithoutProperties3.default)(_ref, ['native']);
	        (0, _classCallCheck3.default)(this, AdNative);
	
	        this.adObj = adObj;
	        this.nativeObj = nativeObj;
	    }
	
	    (0, _createClass3.default)(AdNative, [{
	        key: 'hasCustomType',
	        value: function hasCustomType() {
	            return this.nativeObj.custom && this.nativeObj.custom.type;
	        }
	    }, {
	        key: 'getCustomType',
	        value: function getCustomType() {
	            if (this.nativeObj.desc2) {
	                return this.nativeObj.desc2;
	            }
	
	            if (this.hasCustomType()) {
	                return this.nativeObj.custom.type;
	            }
	
	            return '';
	        }
	    }, {
	        key: 'isContentAd',
	        value: function isContentAd() {
	            return this.getCustomType() === 'content';
	        }
	    }, {
	        key: 'isInhouseAd',
	        value: function isInhouseAd() {
	            return this.getCustomType() === 'inhouse';
	        }
	    }, {
	        key: 'isLocalDomain',
	        value: function isLocalDomain() {
	            return this.nativeObj.clickUrl.indexOf('vg.no') > -1;
	        }
	    }, {
	        key: 'attachClickTracker',
	        value: function attachClickTracker() {
	            var _this = this;
	
	            var link = this.container.querySelector('a');
	
	            link.addEventListener('click', function () {
	                track(_this.nativeObj.clickTrackers);
	            });
	
	            return link;
	        }
	    }, {
	        key: 'createContainer',
	        value: function createContainer(children) {
	            var type = this.getCustomType();
	            var typeClass = type ? 'ad-native-' + type : '';
	            var container = document.createElement('div');
	
	            var template = ('\n            <div class="ad-native ' + typeClass + '">\n                ' + children + '\n            </div>\n        ').trim();
	            container.innerHTML = template;
	
	            return container.firstElementChild;
	        }
	    }, {
	        key: 'getImageRatio',
	        value: function getImageRatio() {
	            var imageData = this.nativeObj.image;
	
	
	            if (!imageData) {
	                return 0;
	            }
	
	            var width = imageData.width,
	                height = imageData.height;
	
	
	            return height / width * 100; // eslint-disable-line no-mixed-operators
	        }
	    }, {
	        key: 'setContainerData',
	        value: function setContainerData(key, value) {
	            this.container.dataset[key] = value;
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var template = '';
	            var nativeObj = (0, _extends3.default)({
	                imageRatio: this.getImageRatio()
	            }, this.nativeObj);
	
	            switch (this.getCustomType()) {
	                case 'content':
	                    template = (0, _nativeTemplates.partnerstudioTemplate)(nativeObj);
	                    break;
	
	                case 'sponsor':
	                    template = (0, _nativeTemplates.sponsorTemplate)(nativeObj);
	                    break;
	
	                case 'inhouse':
	                    template = (0, _nativeTemplates.inhouseTemplate)(nativeObj);
	                    break;
	
	                default:
	                    template = (0, _nativeTemplates.defaultTemplate)(nativeObj);
	            }
	
	            this.container = this.createContainer(template);
	
	            this.setContainerData('creativeId', this.adObj.creativeId);
	            this.attachClickTracker();
	
	            return this.container;
	        }
	    }]);
	    return AdNative;
	}();
	
	function nativeRenderer(adObj) {
	    return new AdNative(adObj).render();
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 766:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.prepareTag = exports.preparePageOptions = exports.nativeRenderer = exports.addKeywordsToTag = undefined;
	
	var _extends2 = __webpack_require__(3);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(50);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _native = __webpack_require__(765);
	
	var _native2 = _interopRequireDefault(_native);
	
	var _helpers = __webpack_require__(72);
	
	var _config = __webpack_require__(183);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getDevice = function getDevice() {
	    if (window && window.vgDevice) {
	        return window.vgDevice;
	    }
	
	    return 'desktop';
	}; /* globals navigator */
	
	
	var getDeviceInvCode = function getDeviceInvCode() {
	    var device = getDevice();
	    var supplyType = '';
	
	    switch (device) {
	        case 'desktop':
	            supplyType = 'wde';
	            break;
	
	        case 'tablet-app':
	            supplyType = 'atb';
	            break;
	
	        case 'tablet':
	            supplyType = 'wtb';
	            break;
	
	        case 'mobile-app':
	            supplyType = 'aph';
	            break;
	
	        case 'mobile':
	            supplyType = 'wph';
	            break;
	
	        default:
	            supplyType = 'wde';
	    }
	
	    return supplyType;
	};
	
	var addExtraSizes = function addExtraSizes(_ref) {
	    var invCode = _ref.invCode,
	        sizes = _ref.sizes;
	
	    var tagsMap = _config.extraSizes[getDevice()];
	
	    if (tagsMap === undefined || tagsMap[invCode] === undefined) {
	        return sizes;
	    }
	
	    return [].concat((0, _toConsumableArray3.default)(tagsMap[invCode]), (0, _toConsumableArray3.default)(sizes));
	};
	
	var prepareTag = function prepareTag(tag) {
	    var device = getDeviceInvCode();
	    var invCode = tag.invCode.replace(/{deviceType}/g, device);
	    var sizes = addExtraSizes(tag, device);
	
	    return (0, _extends3.default)({}, tag, {
	        invCode: invCode,
	        sizes: sizes
	    });
	};
	
	var getFormat = function getFormat(tagOptions) {
	    var invCode = tagOptions.invCode;
	
	    return invCode.split(/_(.+)/)[1];
	};
	
	var addFormat = function addFormat(tagOptions) {
	    return {
	        'no-sno-adformat': getFormat(tagOptions)
	    };
	};
	
	var doNotTrack = function doNotTrack() {
	    return navigator && navigator.doNotTrack === '1' || (0, _helpers.getAdUserId)() === 'DO_NOT_TRACK';
	};
	
	var preparePageOptions = function preparePageOptions(pageOpts) {
	    return (0, _extends3.default)({}, pageOpts, {
	        user: {
	            externalUid: (0, _helpers.getAdUserId)(),
	            dnt: doNotTrack()
	        }
	    });
	};
	
	var addKeywordsToTag = exports.addKeywordsToTag = [addFormat];
	
	exports.nativeRenderer = _native2.default;
	exports.preparePageOptions = preparePageOptions;
	exports.prepareTag = prepareTag;

/***/ }

});


/** WEBPACK FOOTER **
 ** preload.e79a334cc85338cc3923.js
 **/